import { BoldExtension as RemirrorBoldExtension } from 'remirror/extensions'
import { markInputRule } from '@remirror/core'

class BoldExtension extends RemirrorBoldExtension {
  // Added shouldSkip logic
  // valid cases **test**, __test__, **hello world**
  // invalid cases ** test **, __ test __, **test **
  // https://github.com/remirror/remirror/blob/%40remirror/react%402.0.35/packages/remirror__extension-bold/src/bold-extension.ts#L104
  createInputRules() {
    return [
      markInputRule({
        regexp: /(?:\*\*|__)([^*_]+)(?:\*\*|__)$/,
        type: this.type,
        ignoreWhitespace: true,
        shouldSkip: ({ captureGroup }) => {
          if (captureGroup?.trim().length !== captureGroup?.length) return true
          return false
        },
      }),
    ]
  }
}

export default BoldExtension
